import React from 'react';
export const MissionSection = () => {
  return <div className="w-full bg-white text-black py-12" data-id="element-92">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-93">
        <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-94">
          More Than Just Drip
        </h2>
        <div className="flex flex-col gap-8 items-center" data-id="element-95">
          {/* Images placed adjacently */}
          <div className="flex flex-col md:flex-row gap-4 w-full justify-center" data-id="element-96">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jLyn22rHteNienHgKkU7Hj/20250705_2233_Diamond_Measurement_Precision_remix_01jzes7a5gej7vnc12n8dqz35f.png" alt="Precision diamond measurement for FRZN jewelry" className="w-full md:w-1/2 max-w-xs mx-auto rounded-md shadow-lg" data-id="element-97" />
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/t9Pdr3khZqUV4csGiG4Bxh/20250705_2250_Jewelry_Craftsmanship_Focus_remix_01jzet5vrvfvh8vszj77y5z563.png" alt="Detailed craftsmanship of FRZN diamond jewelry" className="w-full md:w-1/2 max-w-xs mx-auto rounded-md shadow-lg" data-id="element-98" />
          </div>
          {/* Text below the images */}
          <div className="max-w-2xl mx-auto" data-id="element-99">
            <p className="text-lg leading-relaxed mb-4" data-id="element-100">
              I wasn't trying to sell products. I was trying to give people like
              me access — to confidence, to style, to a presence that matched
              who they felt they were becoming. It wasn't just about looking
              rich. It was about feeling seen.
            </p>
          </div>
        </div>
      </div>
      {/* Full-width black background section */}
      <div className="w-full bg-black text-white mt-12 py-12" data-id="element-101">
        <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-102">
          <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-103">
            An Invitation to the FRZN World
          </h2>
          <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-104">
            <div className="md:w-1/2" data-id="element-105">
              <p className="text-lg leading-relaxed mb-4" data-id="element-106">
                If you've ever wanted to step into a room and feel like all eyes
                are on you — without paying $1,000 for a chain — I built this
                for you. We keep our drops tight, our quality high, and our
                designs unapologetic.
              </p>
              <p className="text-lg leading-relaxed mb-4" data-id="element-107">
                You're not just buying jewelry. You're stepping into the
                confidence that started it all.
              </p>
              <p className="text-lg leading-relaxed mb-4" data-id="element-108">
                And now, I'm proud to share that we've expanded — FRZN Jewelry
                ships to all 50 states and parts of Canada. This growth means
                everything to me, and it's only possible because of the support
                from people like you. Our new webstore is officially live, and
                I'd love for you to check it out and see what we've been
                building.
              </p>
              <p className="text-xl font-bold" data-id="element-109">Welcome to FRZN.</p>
            </div>
            <div className="md:w-1/2" data-id="element-110">
              <div className="flex flex-col space-y-4" data-id="element-111">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/t8sGaHyJjHSHLqAZAeCPzA/WhatsApp_Image_2025-07-03_at_06.11.30.jpg" alt="FRZN luxury jewelry collection with silver and gold chains" className="w-full rounded-md shadow-lg" data-id="element-112" />
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pQ7NAaWjdGapJDk6511b9x/WhatsApp_Image_2025-07-03_at_06.11.29.jpg" alt="FRZN jewelry collection featuring colored gemstone spikes" className="w-full rounded-md shadow-lg" data-id="element-113" />
              </div>
            </div>
          </div>
          <div className="text-center" data-id="element-114">
            <a href="https://frznjewelry.co/collections/one-day-blow-out-sale" target="_blank" rel="noopener noreferrer" className="mission-cta inline-block bg-white text-black font-bold px-8 py-3 rounded-full text-lg hover:bg-gray-200 transition-colors" data-id="element-115">
              SHOP THE COLLECTION
            </a>
          </div>
        </div>
      </div>
    </div>;
};